import { Box, Button, Flex, HStack, Input, InputGroup, InputLeftElement, Spinner, Text, VStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaBriefcase } from 'react-icons/fa'
import { FaPencil } from 'react-icons/fa6'
import { useParams } from 'react-router-dom'
import { appApi } from '../../../../services/appApi'
import { PropInvalida } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'

// import imgPerfil from '../../assets/pi/perfil.png'//

interface IQuestaoFBP {
  questao: string
  id: string
  respostaObjetiva: boolean
  respostaMultipla?: string[]
  respostaDiscursiva?: string
}

interface IPesquisaBP {
  assessmentId: string
  nome: string
  cargo?: string
  empresa?: string
  urlLogoEmpresa?: string
  questoes: IQuestaoFBP[]
}
export interface Resposta {
  questaoId?: string // Guid representado como string
  questao: string
  respostaBoleana?: boolean
  respostaObjetiva?: boolean
  respostaDiscursiva?: string
  respostaMultipla?: string[]
}

export const PesquisaBP: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const [isLoading, setIsLoading] = useState(true)
  const [isContratado, setIsContratado] = useState(false)

  const [model, setModel] = useState<IPesquisaBP>()
  // const [Busca, setBusca] = useState('')
  const [notFound, setNotFound] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [respostas, setRespostas] = useState<Record<string, Resposta>>({})
  function toggleContratado(contratado: boolean): void {
    setIsContratado(contratado)
  }
  const atualizarResposta = (questaoId: string, dados: Partial<Resposta>): void => {
    setRespostas((prev) => ({
      ...prev,
      [questaoId]: {
        ...prev[questaoId],
        ...dados,
        questaoId // garante que o campo questaoId seja mantido
      }
    }))
  }
  function getAssessment(assessmentId: string): void {
    console.log('obter perfil')
    appApi.get<IPesquisaBP>(`/api/SIFB/${id}/BPResponder`)
      .then(res => {
        if (res.status === 200) {
          // console.log(res.data)
          setModel(res.data)
          setIsLoading(false)
          return
        }
        setNotFound(true)
      })
      .catch(err => { console.log(err); setIsLoading(false) })
  }

  const montarArrayRespostasParaEnvio = (
    respostas: Record<string, Resposta>
  ): Resposta[] => {
    return Object.values(respostas).map((resposta) => ({
      questaoId: resposta.questaoId ?? undefined,
      questao: resposta.questao,
      respostaBoleana: resposta.respostaBoleana ?? undefined,
      respostaObjetiva: resposta.respostaObjetiva ?? undefined,
      respostaDiscursiva: resposta.respostaDiscursiva ?? undefined,
      respostaMultipla: resposta.respostaMultipla ?? undefined
    }))
  }
  function postSurvey(): void {
    setIsLoading(true)

    const arrayParaPostar = montarArrayRespostasParaEnvio(respostas)
    appApi.post(`/api/SIFB/${id}/BPResponder`,
      {
        contratado: isContratado,
        respostas: arrayParaPostar
      }
    )
      .then(res => {
        console.log(res.status)
        console.log(res)
        if (res.status === 200) {
          setEnviado(true)
          setIsLoading(false)
          return
        }
        setNotFound(true)
      })
      .catch(err => { console.log(err); setIsLoading(false) })
  }

  useEffect(() => {
    if (PropInvalida(id)) {
      setNotFound(true)
      return
    }
    getAssessment(id ?? '')
  }, [])

  return (<Body>
    {notFound && <Text>A pesquisa não foi encontrada ou não está mais disponível</Text>}
{isLoading && <Spinner />}
<Flex justify='center'>
<Box width='70rem' maxWidth='90vw' bg='white' borderRadius='lg'>
<Flex direction={'column'} justifyContent='space-between'>

<VStack alignItems='center' p='4'>
<img width={'120rem'} src={model?.urlLogoEmpresa}/>
</VStack>
<VStack alignItems='start' p='4'>
<HStack>
<FaBriefcase size='1.5rem'/>
<Text fontWeight='bold' fontSize='1.8rem' >{model?.nome}</Text>
</HStack>
</VStack>
{!enviado && (

  <>
<Flex flexDirection={'column'} justify={'center'} p={'2rem'}>
<Text fontWeight='bold' fontSize='1.4rem'>O candidato {model?.nome} foi contratado?</Text>
<Flex justify={'center'}>

<Button
onClick={() => toggleContratado(true)}
bg={`var(${isContratado ? '--Green2' : '--c6'})`} width='5rem' height='2.5rem' size='xs' m={3}>Sim</Button>
<Button
onClick={() => toggleContratado(false)}
bg={`var(${isContratado ? '--c6' : '--Rosa'})`} width='5rem' height='2.5rem' size='xs' m={3}>Não</Button>
</Flex>
</Flex>
{/* <VStack> */}
{}

{/* <HStack>
<FaCheck color='var(--Green2)' size='1.5rem' /> */}
{/* <Text ml={2} color='var(--Green2)' fontSize='1.1rem' >Perfis aderentes: { model?.jobTarget.perfisAderentes.map((s, i) => `${s}${i !== model.jobTarget.perfisAderentes.length - 1 ? ',' : ''} `)}</Text> */}
{/* </HStack>
  <HStack>
<FaSync color='var(--Blue1)' size='1.5rem'/> */}
{/* <Text color='var(--a1)' fontSize='1.1rem' ml={2}>Perfis flexibilizados: {model?.jobTarget.perfisAdaptativos.map((s, i) => `${s}${i !== model.jobTarget.perfisAdaptativos.length - 1 ? ',' : ''}`)}</Text> */}
{/* </HStack>
</VStack>
<HStack mr={3}> */}
{/* <Button onClick={() => { window.location.href = `${urlApi}/AssessmentPI/JobTarget/${jobId ?? ''}/csv/?filtro=${3}` }}
 bg='var(--Rosa)' width='10rem' height='2.5rem' size='xs' m={1}><Box mx={3}><FaFileCsv/></Box> Exportar CSV</Button> */}

{/* {!parseJwt().consultoria && (<Button onClick={() => navigate(`/AssessmentPi/JobTarget/Edit/${jobId ?? ''}`)}
 bg='var(--a2)' width='7rem' height='2.5rem' size='xs' m={1}>Editar cargo</Button>)} */}
{/* </HStack> */}

{/* </Flex> */}
{!isContratado && (

  <Flex m='1rem' direction={'column'} >
  {/* {model?.questoes.map((s, i) => <Flex>{s.questao}</Flex>)}
<InputGroup mt='1rem' >
    <InputLeftElement bgColor='white' color='gray.300' borderLeft={'1px'} borderTop={'1px'} borderBottom={'1px'}
    borderRadius='sm' borderColor={'gray.200'}
    pointerEvents='none'
    children={<FaPencil size={'.8rem'} color='gray.300' />}
    />
    <Input bgColor='white' type='tel' placeholder='Digite a resposta'
    value={Busca} onChange={(e) => atualizarResposta(s.id, { respostaDiscursiva: e.target.value })} onKeyPress={e => {
      if (e.key === 'Enter') { getAssessment(id ?? '') }
    }} />
    </InputGroup> */}

    {model?.questoes.map((s, i) => (
  <Box key={s.id} mb="1rem">
    <Flex mb="0.5rem">{s.questao}</Flex>
    <InputGroup>
      <InputLeftElement
        bgColor="white"
        color="gray.300"
        borderLeft="1px"
        borderTop="1px"
        borderBottom="1px"
        borderRadius="sm"
        borderColor="gray.200"
        pointerEvents="none"
        children={<FaPencil size=".8rem" color="gray.300" />}
      />
      <Input
        bgColor="white"
        type="text"
        placeholder="Digite a resposta"
        value={respostas[s.id]?.respostaDiscursiva ?? ''}
        onChange={(e) =>
          atualizarResposta(s.id, {
            questaoId: s.id,
            questao: s.questao,
            respostaDiscursiva: e.target.value
          })
        }
        onKeyPress={(e) => {
          if (e.key === 'Enter') getAssessment(id ?? '')
        }}
      />
    </InputGroup>
  </Box>
    ))}
    </Flex>
)}
<Flex justify={'center'}>

{!enviado && <Button
    onClick={() => postSurvey()}
    bg='var(--Rosa)' width='11rem' height='2.5rem' size='xs' m={3}>
    Responder</Button>}
      </Flex>
</>
)}
{enviado && <Flex height={'20rem'} justifyItems='center' margin={'4rem'}>
   <Text fontWeight={'semibold'} fontSize={'1.2rem'}>Obrigado por participar</Text>
 </Flex>

   }
 </Flex>
    </Box>
 </Flex>

  </Body>)
}
